// extracted by mini-css-extract-plugin
module.exports = {"sportsMenuButton":"_c7d358b"};